import React, { useState, Fragment, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Select from "react-select";
import AddOtherLoanTypes from "./AddOtherLoanTypes";
import { getAllLoanTypes } from "../../actions/shg";
import EditOtherLoanTypes from "./EditOtherLoanTypes";
import Spinner from "../layout/Spinner";
import Pagination from "../layout/Pagination";
import DeactiveOtherLoanTypes from "./DeactiveOtherLoanTypes";
const AllOtherLoanTypes = ({
  auth: { isAuthenticated, user, users },
  shg: { activeInstitutions, allLoanTypes ,loadStatus},
  getAllLoanTypes,
}) => {
  useEffect(() => {
    getAllLoanTypes();
  }, [getAllLoanTypes]);
  const [showAddStateModal, setShowAddStateModal] = useState(false);
  const handleAddStateModalClose = () => setShowAddStateModal(false);
  const onClickHandler = () => {
    setShowAddStateModal(true);
  };

  const onAddStateModalChange = (e) => {
    if (e) {
      handleAddStateModalClose();
    }
  };
  const onUpdateModalChange = (e) => {
    if (e) {
      handleUpdateModalClose();
    }
  };

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const handleUpdateModalClose = () => setShowUpdateModal(false);

  const [userData, setUserData] = useState(null);
  const onEdit = (allLoanTypes, idx) => {
    setShowUpdateModal(true);
    setUserData(allLoanTypes);
  };
  //pagination code
  const [currentData, setCurrentData] = useState(1);
  const [dataPerPage] = useState(5);
  //Get Current Data
  const indexOfLastData = currentData * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentDatas =
    allLoanTypes && allLoanTypes.slice(indexOfFirstData, indexOfLastData);
  //change page
  const paginate = (nmbr) => {
    setCurrentData(nmbr);
  };
  //pagination code ends

  const allinstitution = [];
  // let activeInstitutionData = JSON.parse(
  //   localStorage.getItem("activeInstitutionData")
  // );
  activeInstitutions &&
    activeInstitutions.map((institution) =>
      allinstitution.push({
        institutionId: institution._id,
        label: institution.institutionName,
        value: institution.institutionName,
      }),
    );

  const [institution, getinstitutionData] = useState();

  const [institutionId, setinstitutionId] = useState();
  const [institutionName, setinstitutionName] = useState();

  const onInstitutionChange = (e) => {
    var institutionId = "";
    var institutionName = "";
    getinstitutionData(e);
    institutionId = e.institutionId;
    institutionName = e.value;
    setinstitutionId(institutionId);
    setinstitutionName(institutionName);
    const changeData = {
      institutionIdVal: e.institutionId,
    };
    getAllLoanTypes(changeData);
  };

  const [showDeactiveModal, setShowDeactiveModal] = useState(false);
  const handleDeactiveModalClose = () => setShowDeactiveModal(false);

  const onDeactiveModalChange = (e) => {
    if (e) {
      handleDeactiveModalClose();
    }
  };
  const [userDataDeactive, setUserDataDeactive] = useState(null);
  const onUpdate = (allLoanTypes, idx) => {
    setShowDeactiveModal(true);
    setUserDataDeactive(allLoanTypes);
  };

  return !isAuthenticated || !user || !users ||loadStatus? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align ">
        <section className="sub_reg">
          <div className="row col-lg-11 col-md-12 col-sm-12 col-12 no_padding">
            <div className="row col-lg-5 col-md-11 col-sm-10 col-10">
              <h5 className="heading_color">All Other Loan Types </h5>
              <div className="col-lg-5 col-md-11 col-sm-11 col-11">
                {user.userGroupName === "Super Admin" && (
                  <Select
                    name="institutionName"
                    options={allinstitution}
                    isSearchable={true}
                    value={institution}
                    placeholder="Institution"
                    onChange={(e) => onInstitutionChange(e)}
                    theme={(theme) => ({
                      ...theme,
                      height: 26,
                      minHeight: 26,
                      borderRadius: 1,
                      colors: {
                        ...theme.colors,
                        primary: "black",
                      },
                    })}
                  />
                )}
              </div>
            </div>
            {user.userGroupName !== "Super Admin" &&
              user &&
              user.userGroupName !== "Auditor" && (
                <div className="col-lg-7 col-md-1 col-sm-1 col-1 py-4">
                  <img
                    className="img_icon_size log float-right"
                    onClick={() => onClickHandler()}
                    src={require("../../static/images/add-icon.png")}
                    alt="Add Other Loan Type"
                    title="Add Other Loan Type"
                  />
                </div>
              )}
          </div>

          <div className="row">
            <div className="col-lg-11 col-md-12 col-sm-12 col-12 text-center py-2">
              <section className="body">
                <div className=" body-inner no-padding  table-responsive">
                  <table
                    className="table table-bordered table-striped table-hover"
                    id="datatable2"
                  >
                    <thead>
                      <tr>
                        <th>Other Loan Type</th>
                        {user.userGroupName !== "Super Admin" &&
                          user &&
                          user.userGroupName !== "Auditor" && <th>Op</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {currentDatas &&
                        currentDatas.map((allLoanTypes, idx) => {
                          return (
                            <tr key={idx}>
                              {allLoanTypes.otherLoanTypeStatus &&
                              allLoanTypes.otherLoanTypeStatus ===
                                "Deactive" ? (
                                <td
                                  className=" secondlinebreak1"
                                  style={{ backgroundColor: "#dda6a6" }}
                                >
                                  {allLoanTypes.otherLoanType}
                                </td>
                              ) : (
                                <td className=" secondlinebreak1">
                                  {allLoanTypes.otherLoanType}
                                </td>
                              )}
                              {/* <td>{allLoanTypes.otherLoanType}</td> */}
                              {allLoanTypes.otherLoanTypeStatus &&
                              allLoanTypes.otherLoanTypeStatus !== "Deactive"
                                ? user.userGroupName !== "Super Admin" &&
                                  user &&
                                  user.userGroupName !== "Auditor" && (
                                    <td>
                                      <img
                                        className="img_icon_size log"
                                        onClick={() =>
                                          onUpdate(allLoanTypes, idx)
                                        }
                                        src={require("../../static/images/delete.png")}
                                        alt="Deactivate Other Loan Type"
                                        title="Deactivate Other Loan Type"
                                      />{" "}
                                      &nbsp;
                                      <img
                                        className="img_icon_size log"
                                        onClick={() =>
                                          onEdit(allLoanTypes, idx)
                                        }
                                        src={require("../../static/images/edit_icon.png")}
                                        alt="Edit Other Loan Type"
                                        title="Edit Other Loan Type"
                                      />
                                    </td>
                                  )
                                : user.userGroupName !== "Super Admin" &&
                                  user &&
                                  user.userGroupName !== "Auditor" && (
                                    <td>
                                      Deactivated &nbsp;
                                      <img
                                        className="img_icon_size log "
                                        src={require("../../static/images/info.png")}
                                        alt="Reason"
                                        title={
                                          allLoanTypes.otherLoanTypeDeactiveReason
                                        }
                                      />
                                    </td>
                                  )}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 no_padding">
                    {allLoanTypes && allLoanTypes.length !== 0 ? (
                      <Pagination
                        dataPerPage={dataPerPage}
                        totalData={allLoanTypes.length}
                        paginate={paginate}
                        currentPage={currentData}
                      />
                    ) : (
                      <Fragment />
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 align_right">
                    <label>
                      No. of Other Loan Types : {allLoanTypes.length}
                    </label>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
        <Modal
          show={showAddStateModal}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">Add Other Loan</h3>
            </div>
            <div className="col-lg-2">
              <button onClick={handleAddStateModalClose} className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <AddOtherLoanTypes onAddStateModalChange={onAddStateModalChange} />
          </Modal.Body>
        </Modal>
        <Modal
          show={showUpdateModal}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">Edit Other Loan </h3>
            </div>
            <div className="col-lg-2">
              <button onClick={handleUpdateModalClose} className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <EditOtherLoanTypes
              allLoanTypes={userData}
              onUpdateModalChange={onUpdateModalChange}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={showDeactiveModal}
          backdrop="static"
          keyboard={false}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">Deactivate Other Loan</h3>
            </div>
            <div className="col-lg-2">
              <button onClick={handleDeactiveModalClose} className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <DeactiveOtherLoanTypes
              allLoanTypes={userDataDeactive}
              onDeactiveModalChange={onDeactiveModalChange}
            />
          </Modal.Body>
        </Modal>
      </div>
    </Fragment>
  );
};

AllOtherLoanTypes.propTypes = {
  auth: PropTypes.object.isRequired,
  shg: PropTypes.object.isRequired,
  getAllLoanTypes: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  shg: state.shg,
});

export default connect(mapStateToProps, {
  getAllLoanTypes,
})(AllOtherLoanTypes);
